/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { deleteData, getData, putData } from "utils/Gateway";

import { assetImages } from "constants";
import { getFormatedDateInString } from "helper/EventHelper/EventHelper";

import AddTagModal from "Components/Common/Modals/AddTagModal";
import ConnetModal from "Components/Common/Modals/ConnetModal";
import InitialMeetingModal from "Components/Common/Modals/MeetingModals/InitialMeetingModal";
import SetupMeetingModal from "Components/Common/Modals/MeetingModals/SetupMeetingModal";
import ScheduleConfirmModal from "Components/Common/Modals/MeetingModals/ScheduleConfirmModal";
import MeetingDetailsModal from "Components/Common/Modals/MeetingModals/MeetingDetailsModal";
import ReviewFeedbackModal from "Components/Common/Modals/ReviewFeedbackModal";
import ReviewTab from "../Tabs/ReviewTab";
import AboutTab from "../Tabs/AboutTab";
import ShareModal from "Components/Common/Modals/ShareModal";

const UserDetailsBody = () => {
  const params = useParams();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const fullURL = window.location.href;

  /* use states for top section */
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setuserId] = useState(null);
  const [userName, setuserName] = useState("");
  const [userImage, setuserImage] = useState("");
  const [userPosition, setuserPosition] = useState("");
  const [userCity, setuserCity] = useState("");
  const [userState, setuserState] = useState("");
  const [userCountry, setuserCountry] = useState("");
  const [userRate, setuserRate] = useState("");
  const [userTags, setuserTags] = useState([]);
  const [isProfileOwner, setIsProfileOwner] = useState(false);
  const [isConnect, setIsConnect] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [connectStatus, setConnectStatus] = useState(false);
  const [connectedDate, setConnectedDate] = useState("");
  const [unfriendStatus, setunfriendStatus] = useState("0");
  const [resumeContactOwner, setresumeContactOwner] = useState("0");
  const [resumeContactMember, setresumeContactMember] = useState("0");
  const [userNotExist, setuserNotExist] = useState(false);
  const [userRating, setuserRating] = useState("");
  const [totalNoReviews, setTotalNoReviews] = useState("");
  const [userDetails, setuserDetails] = useState("");
  const [userSkills, setuserSkills] = useState([]);
  const [userEmail, setuserEmail] = useState("");
  const [userLanguage, setuserLanguage] = useState("");
  const [userEducations, setuserEducations] = useState([]);
  const [userExperiences, setuserExperiences] = useState([]);

  const [ratingCount, setRatingCount] = useState("0.0");
  const [reviewsList, setReviewsList] = useState([]);
  const [ratingPercentArr, setRatingPercentArr] = useState([]);

  const [isReviewLoading, setIsReviewLoading] = useState(false);

  const [requestCanceling, setRequestCanceling] = useState(false);
  const [unfriendLoading, setunfriendLoading] = useState(false);
  const [resumeContactLoading, setresumeContactLoading] = useState(false);

  const [comments, setcomments] = useState("");
  const [meetingReason, setmeetingReason] = useState("");

  const [selectedMeetingDate, setSelectedMeetingDate] = useState("");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");

  const [copyMessage, setCopyMessage] = useState("");

  //function for get user details
  const getUserDetails = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GUEST_USER_DETAILS + `/${params.id}`;

      if (userInfo) {
        requestUrl += `?loggedinuserid=${userInfo._id}`;
      }

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("details resp======>", response);

      if (response.status && response.data) {
        setuserNotExist(false);
        const data = response.data;
        setuserId(data._id);
        setuserImage(data.userimage); // Ensure default value if undefined
        setuserName(data.username);
        setuserPosition(data.position || "");

        setuserState(data.state || "");
        setuserCity(data.city || "");
        setuserCountry(data.country || "");
        setuserRating(data.totalratings);
        setTotalNoReviews(data.totalreviews);

        setuserTags(data.taglist);

        setuserEducations(data?.educationids ? data?.educationids : []);
        setuserExperiences(data?.experiencelist ? data?.experiencelist : []);

        if (data.isconnect) {
          setIsConnect(true);
          setRequestDate(data.requestdate);
        } else {
          setIsConnect(false);
          setRequestDate("");
        }

        // if (data.connectstatus) {
        //   setIsuserConnected(true);
        // } else {
        //   setIsuserConnected(false);
        // }

        if (data.connectstatus) {
          setConnectStatus(true);
          setConnectedDate(data.connectdate);
        } else {
          setConnectStatus(false);
          setConnectedDate("");
        }

        if (data.unfriendstatus) {
          setunfriendStatus(data.unfriendstatus);
        }

        if (data.resumecontactowner) {
          setresumeContactOwner(data.resumecontactowner);
        }

        if (data.resumecontactmember) {
          setresumeContactMember(data.resumecontactmember);
        }

        setuserDetails(data.about);
        setuserSkills(data.skills || []); // Ensure default value if undefined
        setuserEmail(data.email || "");
        setuserLanguage(data.language || "");
      } else {
        setuserNotExist(true);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all company reviews
  const getReviewsLists = async () => {
    setIsReviewLoading(true);
    let requestURL =
      url.API_BASE_URL +
      url.API_GET_ALL_USER_REVIEW +
      `?moduleid=${params.id}&moduleslug=user`;

    try {
      const response = await getData(requestURL);

      console.log("review list response", response);

      setIsReviewLoading(false);

      if (response.status) {
        if (response.data) {
          setRatingCount(response.data.rating);
          setReviewsList(response.data.reviews);
          setRatingPercentArr(response.data.ratingbar);
        } else {
          setRatingCount("");
          setReviewsList([]);
          setRatingPercentArr([]);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for cancel request
  const cancelRequestHandler = async () => {
    setRequestCanceling(true);
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_REJECT_CONTACT_REQUEST +
        `?token=${token}&personid=${params.id}`;

      const response = await deleteData(requestURL);
      setRequestCanceling(false);

      console.log(response);

      if (response.status) {
        afterApiCall();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for unfriend contact
  const unfriendHandler = async () => {
    setunfriendLoading(true);
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_UNFRIEND_CONTACT +
        `?token=${token}&personid=${params.id}`;

      const response = await putData(requestURL);

      setunfriendLoading(false);

      console.log(response);

      if (response.status) {
        afterApiCall();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for resume contact
  const resumeContactHandler = async () => {
    setresumeContactLoading(true);
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_RESUME_CONTACT +
        `?token=${token}&personid=${params.id}`;

      const response = await putData(requestURL);

      setresumeContactLoading(false);

      console.log(response);

      if (response.status) {
        afterApiCall();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //fucntion for get api
  const afterApiCall = () => {
    getUserDetails();
    getReviewsLists();
  };

  //resetScheduleMeet
  const resetScheduleMeet = () => {
    setmeetingReason("");
    setcomments("");
    setSelectedMeetingDate("");
    setSelectedTimeSlot("");
  };

  //share function
  const shareHandler = () => {
    if (token) {
      const redirectUrl = fullURL + `?refcode=${userInfo.referralcode}`;
      setCopyMessage(redirectUrl);
      const bootstrapModal = new bootstrap.Modal(
        document.getElementById("share_mdl")
      );
      bootstrapModal.show();
    }
  };

  useEffect(() => {
    if (params.id) {
      getUserDetails();
      getReviewsLists();
    }
  }, [params.id]);

  return (
    <>
      {/* upper section */}
      <div className="event_details_sec bg_white">
        <div className="container">
          <div className="details_top_row">
            <div className="container">
              <div className="row">
                {/* name,image,contry */}
                <div className="col-lg-7">
                  <div className="topdetails_left">
                    <div className="userholder_outer d-flex gap-3">
                      <div className="users_holderPic rounded-circle overflow-hidden">
                        <img
                          src={
                            userImage == ""
                              ? assetImages.defaultUser
                              : url.SERVER_URL + userImage
                          }
                          className="h-100 w-100 object-cover"
                          alt=""
                        />
                      </div>
                      <div className="users_holdertext">
                        <h3 className="fs-lg text-uppercase mb-4">
                          {userName}
                          <span className="d-block fs-sm font-body">
                            {userPosition}
                          </span>
                        </h3>
                        <div className="details_tags user_details d-flex align-items-center gap-2">
                          <div className="btn primary-btn">
                            <i className="material-icons-outlined icon-fill fs-lg">
                              star
                            </i>
                            <span>{userRating}</span>
                            <h6>({totalNoReviews})</h6>
                          </div>
                          <div className="jb_rating">
                            <i className="material-icons-outlined icon-fill fs-lg">
                              place
                            </i>
                            <span className="text-primary fs-sm">
                              {userCity} {userState} {userCountry}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* tag,share,connect */}
                <div className="col-lg-5">
                  <div className="topdetails_right">
                    {token && (
                      <div className="expartbttm_area">
                        <div className="exprt_share">
                          <ul className="list_style_none d-flex align-items-center justify-content-end mb-3 gap-2 flex-wrap">
                            <li>
                              <Link
                                to="#"
                                className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden bg_gray"
                                data-bs-toggle="modal"
                                data-bs-target="#addtag_mdl"
                              >
                                <i className="material-icons-outlined text-primary-gray fs-lg">
                                  more
                                </i>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                // data-bs-toggle="modal"
                                // data-bs-target="#share_mdl"
                                className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden bg_gray"
                                onClick={shareHandler}
                              >
                                <i className="material-icons-outlined fs-lg text-primary-gray">
                                  share
                                </i>
                              </Link>
                            </li>
                          </ul>
                        </div>

                        <div className="users_skill activity_skill d-flex gap-2 justify-content-end">
                          <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
                            {userTags.slice(0, 4).map((tagData, index) => {
                              return (
                                <li key={index}>
                                  <Link
                                    to="#"
                                    className="d-flex align-items-center py-2 px-3 bg_gray rounded-4 fs-sm"
                                  >
                                    {tagData}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                          {userTags.length > 4 ? (
                            <div className="more_tags">
                              <Link
                                to="#"
                                className="d-flex align-items-center py-2 px-3 text-pink rounded-4 fs-sm"
                              >
                                +{userTags.length - 4}
                              </Link>
                            </div>
                          ) : null}
                        </div>

                        {params.id.toString() ===
                        userInfo._id.toString() ? null : (
                          <div className="feedback_jointbtnOuter mt-5">
                            <div className="details_apply mb-3 d-flex gap-3 justify-content-end">
                              {/* isconnect = user send request */}
                              {isConnect ? (
                                connectStatus ? (
                                  <div className="connected_info d-flex align-items-center gap-3 justify-content-end">
                                    <button
                                      className="btn"
                                      onClick={unfriendHandler}
                                      disabled={unfriendLoading ? true : false}
                                      style={{
                                        cursor: unfriendLoading
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                    >
                                      Unfriend
                                      {unfriendLoading && (
                                        <div
                                          className="mx-2 spinner-border spinner-border-sm"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                ) : unfriendStatus === "1" ? (
                                  resumeContactOwner == "1" ||
                                  resumeContactMember == "1" ? (
                                    <button
                                      className="btn"
                                      onClick={resumeContactHandler}
                                      disabled={
                                        resumeContactLoading ? true : false
                                      }
                                      style={{
                                        cursor: resumeContactLoading
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                    >
                                      Resume Contact
                                      {resumeContactLoading && (
                                        <div
                                          className="mx-2 spinner-border spinner-border-sm"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      )}
                                    </button>
                                  ) : null
                                ) : (
                                  <div className="connected_info d-flex align-items-center gap-3 justify-content-end">
                                    <button
                                      className="btn"
                                      onClick={cancelRequestHandler}
                                      disabled={requestCanceling ? true : false}
                                      style={{
                                        cursor: requestCanceling
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                    >
                                      Cancel Request
                                      {requestCanceling && (
                                        <div
                                          className="mx-2 spinner-border spinner-border-sm"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                )
                              ) : (
                                <Link
                                  to="#"
                                  className="btn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#connect_modal"
                                >
                                  Connect
                                </Link>
                              )}

                              <Link
                                to="#"
                                className="btn primary-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#intial_meet_modal"
                              >
                                Meet
                              </Link>
                            </div>

                            {/* connected / request date */}
                            {connectedDate === "" ? (
                              requestDate === "" ? null : (
                                <p className="d-flex align-items-center justify-content-end">
                                  <i className="material-icons">check_circle</i>
                                  <span>
                                    Request send on{" "}
                                    {getFormatedDateInString(requestDate)}
                                  </span>
                                </p>
                              )
                            ) : (
                              <p className="d-flex align-items-center justify-content-end">
                                <i className="material-icons">check_circle</i>
                                <span>
                                  Conected on{" "}
                                  {getFormatedDateInString(connectedDate)}
                                </span>
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="details_bttm_tabs">
            <div className="tab_links">
              <ul className="nav nav-tabs mb-0">
                <li className="nav-item">
                  <button
                    className="nav-link active text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#about"
                  >
                    About
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#review"
                  >
                    Review
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* tab section */}
      <section className="event_sec placeholder-glow">
        <div className="container">
          <div className="tab-content">
            <div className="tab-pane fade show active" id="about">
              <AboutTab
                userLanguage={userLanguage}
                userEmail={userEmail}
                userSkills={userSkills}
                userExperiences={userExperiences}
                userDetails={userDetails}
              />
            </div>

            <div className="tab-pane fade" id="review">
              <ReviewTab
                token={token}
                connectStatus={connectStatus}
                ratingCount={ratingCount}
                reviewsList={reviewsList}
                ratingPercentArr={ratingPercentArr}
              />
            </div>
          </div>
        </div>
      </section>

      {/* modals */}

      {/* tag modal */}
      {token && (
        <AddTagModal
          moduleName={"appuser"}
          selectedId={params.id}
          onModalClose={afterApiCall}
        />
      )}

      {/* connect modal */}
      {token && (
        <ConnetModal
          token={token}
          personId={userId}
          personName={userName}
          setPersonId={setuserId}
          setPersonName={setuserName}
          afterModalClose={afterApiCall}
        />
      )}

      <InitialMeetingModal
        personName={userName}
        setcomments={setcomments}
        setmeetingReason={setmeetingReason}
      />

      <SetupMeetingModal
        token={token}
        personId={userId}
        personName={userName}
        setSelectedMeetingDate={setSelectedMeetingDate}
        setSelectedTimeSlot={setSelectedTimeSlot}
        selectedTimeSlot={selectedTimeSlot}
        setcomments={setcomments}
        setmeetingReason={setmeetingReason}
      />

      <MeetingDetailsModal
        token={token}
        personId={userId}
        personName={userName}
        setSelectedMeetingDate={setSelectedMeetingDate}
        selectedMeetingDate={selectedMeetingDate}
        setSelectedTimeSlot={setSelectedTimeSlot}
        selectedTimeSlot={selectedTimeSlot}
        meetingReason={meetingReason}
        comments={comments}
      />

      <ScheduleConfirmModal
        personName={userName}
        selectedTimeSlot={selectedTimeSlot}
        selectedMeetingDate={selectedMeetingDate}
        onModalClose={resetScheduleMeet}
      />

      {token && (
        <ReviewFeedbackModal
          moduleName={"user"}
          onModalClose={afterApiCall}
          moduleId={userId}
        />
      )}

      {token && <ShareModal copyMessage={copyMessage} />}
    </>
  );
};

export default UserDetailsBody;
